import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M19.65.75 15.9 3l2.25 3.75",
			stroke: "#595959",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.25 8.19a6.73 6.73 0 0 0-6.88-4.42M4.35 23.25 8.1 21l-2.25-3.75",
			stroke: "#595959",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M.75 15.81a6.73 6.73 0 0 0 6.88 4.42M2.25.75h9s1.5 0 1.5 1.5v9s0 1.5-1.5 1.5h-9s-1.5 0-1.5-1.5v-9s0-1.5 1.5-1.5Zm13.5 10.5h6a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-6M15.5 18H19M6.75 3.75v1.5m-3 0h6",
			stroke: "#595959",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.25 5.25s-1.5 4.5-4.5 4.5",
			stroke: "#595959",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.75 8a3.92 3.92 0 0 0 3 1.73m5.75 10.52v-4a1.75 1.75 0 0 1 3.5 0v4",
			stroke: "#595959",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M19.65.75%2015.9%203l2.25%203.75%22%20stroke%3D%22%23595959%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M23.25%208.19a6.73%206.73%200%200%200-6.88-4.42M4.35%2023.25%208.1%2021l-2.25-3.75%22%20stroke%3D%22%23595959%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M.75%2015.81a6.73%206.73%200%200%200%206.88%204.42M2.25.75h9s1.5%200%201.5%201.5v9s0%201.5-1.5%201.5h-9s-1.5%200-1.5-1.5v-9s0-1.5%201.5-1.5Zm13.5%2010.5h6a1.5%201.5%200%200%201%201.5%201.5v9a1.5%201.5%200%200%201-1.5%201.5h-9a1.5%201.5%200%200%201-1.5-1.5v-6M15.5%2018H19M6.75%203.75v1.5m-3%200h6%22%20stroke%3D%22%23595959%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M8.25%205.25s-1.5%204.5-4.5%204.5%22%20stroke%3D%22%23595959%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M6.75%208a3.92%203.92%200%200%200%203%201.73m5.75%2010.52v-4a1.75%201.75%200%200%201%203.5%200v4%22%20stroke%3D%22%23595959%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E";
